export const MODAL_ID = "_picket_connect_modal";

export const MSG_OPEN = "PICKET_CONNECT_OPEN";
export const MSG_CLOSE = "PICKET_CONNECT_CLOSE";
export const MSG_SUCCESS = "PICKET_CONNECT_SUCCESS";
